export default class Meta {
    name = '';
    color = '';
    id = '';

    constructor() {
    }
}
